import { Dialog, DialogContent, DialogTitle } from '@leadsnavi/ui-kit';
import useUserProfile from '@/stores/user-profile';
import AccountPage from './page';

export default function UserProfileModalProvider() {
  const { open } = useUserProfile();

  return (
    <Dialog open={open}>
      <DialogTitle hidden />
      <DialogContent
        showCloseButton={false}
        className="w-[700px] min-w-[700px] p-0"
        onOpenAutoFocus={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <AccountPage />
      </DialogContent>
    </Dialog>
  );
}
